var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-layout',{attrs:{"align-center":"","justify-center":""}},[_c('h1',{staticClass:"ma-5"},[_vm._v("Welkom!")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }